"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClosestDate = void 0;
const index_1 = __importDefault(require("date-fns/addDays/index"));
const utils_1 = require("./utils");
/**
 * Finds the closest available checkin/checkout date from a given date that is not available.
 * @function
 * @param {string} disabledDate - The disabled date in YYYY-MM-DD format, that a user clicked on while choosing check-in/check-out date.
 * @param {ParserInputDateObj} today - The current date in the vacation rental's time zone. This is found in the ParserInputConfig.currentDate
 * @param {ParserOutput} parsedAvailability - parsed availability data (the output of parseAvailability())
 * @param {MatchCriteriaObj} matchCriteria - Criteria that must be met for a date to be returned
 * @param {boolean} leanEarly - If true will prioritize returning a date earlier in the calendar. Set to true if date picker focus is on checkin
 * @returns {string} - a date string of the format YYYY-MM-DD
 */
function getClosestDate({ disabledDate, today, parsedAvailability, matchCriteria, leanEarly, }) {
    if (!(0, utils_1.canHaveClosestDate)(disabledDate, parsedAvailability, matchCriteria)) {
        return null;
    }
    const dateRangeSize = Object.keys(parsedAvailability).length;
    const closestToDate = new Date(disabledDate);
    for (let i = 0; i < dateRangeSize; i++) {
        const addedDay = (0, index_1.default)(closestToDate, i);
        const subtractedDay = (0, index_1.default)(closestToDate, -i);
        const futureDate = (0, utils_1.prepDateForComparison)(parsedAvailability, addedDay, matchCriteria, today);
        const pastDate = (0, utils_1.prepDateForComparison)(parsedAvailability, subtractedDay, matchCriteria, today);
        if (!futureDate || !pastDate) {
            return null;
        }
        const closestDate = (0, utils_1.chooseClosestDate)(futureDate, pastDate, leanEarly);
        if (closestDate) {
            return closestDate;
        }
    }
    /* istanbul ignore next */
    return null;
}
exports.getClosestDate = getClosestDate;
